import {store} from "../App";


export function setIsItineraryShown(shown) {
    store.dispatch({type: "SET_IS_ITINERARY_SHOWN", isItineraryShown: shown});
}

export function setIsDashboardShown(shown) {
    store.dispatch({type: "SET_IS_DASHBOARD_SHOWN", isDashboardShown: shown});
}